import { forkJoin, Observable, of, race, Subscription, throwError } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';

export class CorrelationActionObserver {
  constructor(private actions$: Actions) {}

  observeActions$(actions: ActionWithCorrelationAttributes[]): Observable<void[]> {
    return forkJoin(
      actions.map((action) => this.observeAction$(action))
    );
  }

  observeAction$(action: ActionWithCorrelationAttributes): Observable<void> {
    return race(
      this.waitForCorrelationType$(
        action.__correlationId,
        action.__successActionType
      ).pipe(switchMap(() => of(null))),
      this.waitForCorrelationType$(
        action.__correlationId,
        action.__errorActionType
      ).pipe(switchMap(() => throwError('Noo')))
    );
  }

  subscribeToAction(
    action: ActionWithCorrelationAttributes,
    onSuccess: () => void,
    onError?: () => void
  ): Subscription {
    return this.observeAction$(action).subscribe(onSuccess, onError);
  }

  protected waitForCorrelationType$(
    correlationId: string,
    type: string
  ): Observable<void> {
    return this.actions$.pipe(
      ofType<ActionWithCorrelationAttributes>(type),
      filter(newAction => newAction.__correlationId === correlationId),
      take(1),
      switchMap(newAction => {
        return of(null);
      })
    );
  }
}
